var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIconMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.24 10.0502V12.7502V12.7952C13.24 13.6952 12.475 14.4152 11.575 14.4152H7.705H5.635L2.755 16.4852L2.665 14.4152C1.765 14.4152 1 13.6502 1 12.7502V7.53023C1 6.58523 1.72 5.86523 2.665 5.86523H9.19",
    stroke: "#310048",
    strokeWidth: 1.1344,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.24 12.84H16.48C17.245 12.84 17.83 13.47 17.83 14.235V18.555C17.83 19.32 17.2 19.95 16.48 19.95L16.39 21.615L14.005 19.905H9.1C8.335 19.905 7.75 19.275 7.75 18.51V14.415M19.72 10.05L19.63 12.12L16.75 10.05H10.81C9.91 10.05 9.145 9.285 9.145 8.385V3.165C9.145 2.22 9.865 1.5 10.81 1.5H19.765C20.665 1.5 21.43 2.265 21.43 3.165V8.385C21.43 9.33 20.665 10.05 19.72 10.05Z",
    stroke: "#310048",
    strokeWidth: 1.1344,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.24 12.8398H16.48C17.245 12.8398 17.83 13.4698 17.83 14.2348V18.5548C17.83 19.3198 17.2 19.9498 16.48 19.9498L16.39 21.6148L14.005 19.9048H9.1C8.335 19.9048 7.75 19.2748 7.75 18.5098V14.4148L13.24 12.8398Z",
    fill: "#A90057",
    stroke: "#310048",
    strokeWidth: 0.968,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7656 15.8096H14.8156",
    stroke: "#FAFBFB",
    strokeWidth: 0.968,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7656 17.5645H14.8156",
    stroke: "#FAFBFB",
    strokeWidth: 0.968,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.24 10.0502V12.7502V12.7952C13.24 13.6952 12.475 14.4152 11.575 14.4152H7.705H5.635L2.755 16.4852L2.665 14.4152C1.765 14.4152 1 13.6502 1 12.7502V7.53023C1 6.58523 1.72 5.86523 2.665 5.86523H9.19L13.24 10.0502Z",
    fill: "#FAFBFB",
    stroke: "#310048",
    strokeWidth: 0.968,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7195 10.05L19.6295 12.12L16.7495 10.05H10.8095C9.90953 10.05 9.14453 9.285 9.14453 8.385V3.165C9.14453 2.22 9.86453 1.5 10.8095 1.5H19.7645C20.6645 1.5 21.4295 2.265 21.4295 3.165V8.385C21.4295 9.33 20.6645 10.05 19.7195 10.05Z",
    fill: "#755484",
    stroke: "#310048",
    strokeWidth: 0.968,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6992 4.83008H17.8742",
    stroke: "#FAFBFB",
    strokeWidth: 0.968,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6992 6.76465H17.8742",
    stroke: "#FAFBFB",
    strokeWidth: 0.968,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIconMessage);
export default __webpack_public_path__ + "static/media/card_icon_message.70ffc06cf29d6d0f6180ee5025a9f4b0.svg";
export { ForwardRef as ReactComponent };